import { useMutation } from '@tanstack/react-query'
import { executeHttpServiceGet } from 'api/admin/httpServices/executeHttpServiceGet'

// Read-only upstream call; nothing in our cache to invalidate.
export const useExecuteHttpServiceGetMutation = () =>
  useMutation({ mutationFn: executeHttpServiceGet })
